import { FlexBox, Icon, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const ChartYAxis = () => {
  const theme = useStatsTheme((s) => s.theme)

  return (
    <FlexBox
      className={css`
        padding-right: 6.5px;
        height: 179px;
        background-color: ${theme.colors.section.bg};
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
      `}
      flexDirection="column"
      alignItems="flex-end"
      justifyContent="space-between"
    >
      {[0, 1, 2, 3, 4, 5].reverse().map((r) => (
        <FlexBox
          key={r}
          className={css`
            gap: 2px;
          `}
          alignItems="center"
        >
          <span
            className={css`
              width: 2px;
              height: 1px;
              background-color: ${theme.colors.section.textSecondary};
            `}
          />
          <Text
            type="body"
            className={css`
              font-size: 8px;
              line-height: 8px;
            `}
            color={theme.colors.section.textSecondary}
          >
            {r.toString()}
          </Text>
          <Icon
            type="star-solid"
            className={css`
              width: 9px;
            `}
            fill={theme.colors.section.textSecondary}
          />
        </FlexBox>
      ))}
    </FlexBox>
  )
}
